export const getAccountFrontData = <T extends Record<string, any> = Record<string, any>>(): T => {
  if (typeof window === 'undefined') {
    return {} as T;
  }

  const globals = window as any;
  return (globals.ipsOrderAccountFrontData || globals.ipsReactFrontData || {}) as T;
};
